
import { store }           from 'index';
import { SET_MODAL_STATE } from 'actions/modalActions';

const closeModal = () => {

    const state     = store.getState();
    const { modal } = state;

    store.dispatch(SET_MODAL_STATE({
        ...modal,
        showModal: false
    }))
}

export default closeModal